import { useCallback } from 'react';

import type { FieldValues, UseFormSetError } from 'react-hook-form';
export type HttpError = Error & {
  response?: {
    status?: number;
    data?: string;
  };
};

export function useHttpHandleError<T extends FieldValues>(
  setError: UseFormSetError<T>,
) {
  return useCallback(
    (errorData: HttpError) => {
      const statusCode = errorData.response?.status ?? 0;
      let errorMessage = '';
      errorMessage = errorData.response?.data ?? '';
      setError('root', {
        types: {
          title: `Error ${statusCode ? `(${statusCode.toString()})` : 'Unknown'}`,
          details: '',
          message: errorMessage,
        },
      });
    },
    [setError],
  );
}
